<template>
  <div class="container">
    <!-- 对话历史展示区域 -->
    <div class="chat-history" ref="chatBox">
      <!-- 提问提示区域 -->
      <div class="prompt-box">
        <h3>您可以试着这样提问本课程相关的问题</h3>
        <ul class="question-list">
          <li
            v-for="(item, index) in questions"
            :key="index"
            @click="handleQuickQuestion(item.text)"
          >
            <span :class="['dot', item.color]"></span>
            {{ item.text }}
            <img src="@/assets/Stroke.png" class="arrow-icon"></img>
          </li>
        </ul>
      </div>
      <div
        style="margin-top: 10px"
        v-for="(msg, index) in messages"
        :key="index"
        :class="['message', `message-${msg.type}`]"
      >
        <div class="avatar">
          <img
            :src="msg.type === 'user' ? userAvatar : aiAvatar"
            :alt="msg.type === 'user' ? '用户头像' : 'AI头像'"
          >
        </div>
        <div class="content">
          <div v-html="formatMessage(msg.content)"></div>
          <div class="time">{{ formatTime(msg.timestamp) }}</div>
        </div>
        <div v-if="currentAIMessage" class="message-bubble ai typing">
          <div v-html="formatMessage(currentAIMessage)"></div>
          <div class="time">{{ formatTime(msg.timestamp) }}</div>
        </div>

      </div>
    </div>

    <!-- 输入交互区域（包含顶部提问提示） -->
    <div class="input-box">
      <!-- 输入文本框 -->
      <textarea
        v-model="question"
        placeholder="试着输入您想了解的问题吧。输入Shift+Enter是换行哦~"
        rows="3"
        @keydown="handleKeydown"
      ></textarea>

      <!-- 控制栏（开关+发送按钮） -->
      <div class="control">
        <!--<label class="switch">
          <input type="checkbox" v-model="deepThinking">
          <span class="slider">深度思考 DeepSeek R1</span>
        </label>-->
        <button
          class="send-btn"
          @click="handleSend"
          :disabled="!question.trim() || isSending"
        >
          <span v-if="!isSending">发送</span>
          <span v-else>发送中...</span>
          <img v-if="!isSending" style="width: 20px;margin-left: 10px" src="@/assets/icons/send.png"/>
        </button>
      </div>
    </div>

    <p class="disclaimer">以上内容由AI大模型生成，不代表我们的态度和观点，请仔细甄别</p>
  </div>
</template>

<script>
  import userAvatar from '@/assets/user.png'
  import aiAvatar from '@/assets/ai.png'
  import axios from "axios";
  const { marked } = require('marked')
  export default {
    data() {
      return {
        sessionIds: {
          chat: null,
          vr: null,
          video: null
        },
        currentAIMessage: '',
        isThinking: false,
        question: '',                 // 当前输入的问题
        deepThinking: false,          // 深度思考开关状态
        isSending: false,             // 发送状态标记
        messages: [],                 // 对话历史数组
        questions: [                  // 快捷提问列表
          { color: 'blue', text: '节流调速回路中，节流阀和调速阀各有什么特点？' },
          { color: 'pink', text: '简述单活塞杆液压缸的基本工作原理' },
          { color: 'green', text: '请描述径向柱塞泵的工作原理，并说明其结构特点及局限性' },
          { color: 'blue', text: '双作用叶片泵的工作原理是什么？它与单作用叶片泵的主要区别在哪里？' },
        ],
        userAvatar,  // 用户头像占位图
        aiAvatar  // AI头像占位图
      };
    },
    methods: {
      formatMessage(text) {
        if (!text) return '';
        let formatted = text
          .replace(/```json/g, '<pre class="code"><code>')
          .replace(/```/g, '</code></pre>');
        return marked(formatted.replace(/\n/g, '<br/>'));
      },
      /**
       * 处理消息发送逻辑
       */
      async handleSend2() {
        const input = this.question.trim();
        // 输入为空或正在发送时不处理
        if (!input || this.isSending) return;

        // 添加用户消息到对话历史
        this.messages.push({
          type: 'user',
          content: input,
          timestamp: new Date()
        });

        // 清空输入框
        this.question = '';
        // 标记为发送中状态
        this.isSending = true;

        try {
          // 模拟API请求（实际使用时替换为真实接口调用）
          const response = await this.simulateApiRequest(input);

        } catch (error) {
          // 异常处理：添加错误提示消息
          this.messages.push({
            type: 'ai',
            content: '抱歉，当前无法为您提供解答，请稍后再试',
            timestamp: new Date()
          });
        } finally {
          // 无论成功或失败都重置发送状态
          this.isSending = false;
        }
      },
      scrollToBottom() {
        const box = this.$refs.chatBox;
        if (box) {
          box.scrollTop = box.scrollHeight;
        }
      },
      async handleSend() {
        if (!this.question.trim()) return;

        const userText = this.question;
        // 添加用户消息前，先检查该消息是否已经存在（避免重复）
        if (!this.messages.some(msg => msg.text === userText && msg.role === 'user')) {
          this.messages.push({ type: 'user', content: userText,timestamp: new Date() });
          // 添加AI回复到对话历史
          this.messages.push({
            type: 'ai',
            content: "小明正在思考中...",
            timestamp: new Date()
          });
          this.$nextTick(() => this.scrollToBottom())
        }

        this.question = '';
        this.isThinking = true;
        // 标记为发送中状态
        this.isSending = true;

        await Promise.all([
          this.requestAgent('chat',userText,3),
          /*this.requestAgent('vr', '270f19b806fa11f08dbf0242ac130003', userText, false),
          this.requestAgent('video', '24eedf9c143d11f0bbe60242ac130006', userText, false)*/
        ]);
      },
      async requestAgent(type,userText,flag){
        try {
          const response = await axios.post('/chat', {
            query: userText,
            user: "abc-123",
            type: flag
          });

          try {
            if (type === 'vr') {
              var responseData = JSON.parse(JSON.parse(response.data.slice(5).trim().replace(/^"|"$/g, '').replace(/\\\\/g, '\\')).content).answer
              this.videoList = responseData.map(item => ({
                title: item['data0'] || '',
                path: item['data4'].replace("http://keming365.com/user/showPPT", 'https://yq.keming365.com/webclient') || '',
                img: item['data3'] || ''
              })).filter(item => item.title && item.path && item.img);
            } else if (type === 'video') {
              var responseData = JSON.parse(JSON.parse(response.data.slice(5).trim().replace(/^"|"$/g, '').replace(/\\\\/g, '\\')).content).answer
              this.vrList = responseData.map(item => ({
                title: item['data0'] || '',
                path: item['data4'] || '',
                img: item['data3'] || ''
              })).filter(item => item.title && item.path && item.img);
            } else if (type === 'chat') {
              var responseData = JSON.parse(response.data.slice(5).trim().replace("'",'\"').replace(/\\\\/g, '\\')).content;
              this.startTyping(responseData.replace(/['"]/g, '').replace(/```json/g, '<pre class="code"><code>')
                .replace(/```/g, '</code></pre>')
                .replace(/\n{2,}/g, '<br><br>') // 多个换行转换为段落间隔
                .replace(/#### /g, '<h4>') // 四级标题转换为 h4 标签
                .replace(/\n- /g, '<br>- ').replace(/\n/g, '<br/>'));
            }

          } catch (error) {
            console.error('解析失败：', error.message, '原始数据：', response.data);
          }
          // 去掉 JSON 中的 code块标记符
        } catch (err) {
          this.conversationError = '对话请求失败，请稍后再试';
        } finally {
          this.isThinking = false;
        }
      },
      startTyping(fullText) {
        this.currentAIMessage = '';
        this.typingIndex = 0;
        this.typingText = fullText;

        const typing = () => {
          if (this.messages.length > 0) {
            const lastMessage = this.messages[this.messages.length - 1];
            lastMessage.content = fullText; // 直接修改
          }
          this.isSending = false;
          this.$nextTick(() => this.scrollToBottom())
        };

        typing();
      },

      /**
       * 模拟API请求（实际使用时替换为真实接口）
       * @param {string} question 用户输入的问题
       * @returns {Promise<string>} AI回复内容
       */
      simulateApiRequest(question) {
        return new Promise((resolve) => {
          // 模拟1.5秒的网络延迟
          setTimeout(() => {
            // 预设的回复内容（可根据实际需求扩展）
            const responses = [
              '这个知识点需要结合实际案例理解，建议先阅读教材第3章内容，重点关注视觉元素的构成原理...',
              '关于该发展阶段，主要分为三个时期：萌芽期（1900-1930）、发展期（1930-1970）、成熟期（1970至今），具体特征包括...',
              '当前图片造假问题主要涉及AI生成和PS修改，鉴别时需注意像素连贯性、光影一致性和元数据验证...',
              '成为“好色之徒”需要培养色彩敏感度，建议每天做30分钟色彩练习（如色卡匹配、场景调色）...'
            ];
            // 随机选择一个回复（实际应根据question内容返回对应答案）
            const randomIndex = Math.floor(Math.random() * responses.length);
            resolve(responses[randomIndex]);
          }, 1500);
        });
      },

      /**
       * 处理快捷问题点击（填充输入框）
       * @param {string} text 快捷问题文本
       */
      handleQuickQuestion(text) {
        this.question = text;
      },

      /**
       * 处理键盘事件（支持Shift+Enter换行）
       * @param {KeyboardEvent} e 键盘事件对象
       */
      handleKeydown(e) {
        // 普通Enter键触发发送（非Shift+Enter）
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault(); 1
          this.handleSend();
        }
      },

      /**
       * 格式化时间显示（HH:MM格式）
       * @param {Date|string} timestamp 时间戳
       * @returns {string} 格式化后的时间字符串
       */
      formatTime(timestamp) {
        const date = new Date(timestamp);
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
      }
    }
  };
</script>

<style scoped>
  .container {
    font-family: 'Segoe UI', sans-serif;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }

  /* 对话历史样式 */
  .chat-history {
    height: 400px;
    overflow-y: auto;
    margin-bottom: 20px;
    padding: 10px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
  }

  .message {
    display: flex;
    margin-bottom: 20px;
  }

  .message-user {
    flex-direction: row-reverse; /* 用户消息右对齐 */
  }

  .avatar {
    width: 40px;
    height: 40px;
    margin: 0 10px;
    flex-shrink: 0; /* 防止头像被压缩 */
  }

  .avatar img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }

  .content {
    max-width: 70%;
    padding: 12px 16px;
    border-radius: 12px;
    word-wrap: break-word; /* 长文本换行 */
  }

  .message-user .content {
    background-color: #646cff;
    color: white;
    margin-left: auto; /* 右对齐 */
  }

  .message-ai .content {
    background-color: #f3f4f6;
    color: #111827;
    margin-right: auto; /* 左对齐 */
  }

  .text {
    margin-bottom: 6px;
    line-height: 1.5;
    font-size: 15px;
  }

  .time {
    font-size: 12px;
    color: #9ca3af;
    text-align: right;
    margin-top: 4px;
  }

  /* 输入区域样式 */
  .input-box {
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  /* 提问提示区域 */
  .prompt-box {
    background: #f8f9fa;
    border-radius: 10px 10px 0 0;
    padding: 15px;
    border-bottom: 1px solid #e5e7eb;
  }

  .prompt-box h3 {
    margin: 0 0 10px 0;
    color: #374151;
    font-size: 16px;
  }

  .question-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .question-list li {
    display: flex;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #e5e7eb;
    cursor: pointer;
    transition: background 0.2s;
    font-size: 14px;
    color: #4b5563;
  }

  .question-list li:last-child {
    border-bottom: none; /* 最后一项不显示底部分隔线 */
  }

  .question-list li:hover {
    background-color: #f3f4f6;
  }

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 10px;
    flex-shrink: 0; /* 防止圆点被压缩 */
  }

  .blue { background-color: #646cff; }
  .pink { background-color: #ff6b9c; }
  .green { background-color: #4caf50; }

  .arrow-icon {
    margin-left: auto;
    width: 10px;
  }

  /* 输入文本框样式 */
  textarea {
    width: 100%;
    border: none;
    resize: none;
    background: transparent;
    padding: 15px;
    font-size: 16px;
    margin-bottom: 0;
    transition: background 0.2s;
  }

  textarea:focus {
    outline: none;
    background: #f8f9fa;
  }

  /* 控制栏样式 */
  .control {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px 15px;
  }

  .switch {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #6b7280;
    font-size: 14px;
  }

  .switch input {
    /* 隐藏默认复选框 */
    appearance: none;
    width: 36px;
    height: 20px;
    background: #e5e7eb;
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    transition: background 0.2s;
  }

  .switch input:checked {
    background: #646cff;
  }

  .switch input::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 16px;
    height: 16px;
    background: white;
    border-radius: 50%;
    transition: left 0.2s;
  }

  .switch input:checked::after {
    left: 18px;
  }

  .send-btn {
    background: #646cff;
    border: none;
    border-radius: 6px;
    padding: 8px 16px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: opacity 0.2s;
    font-size: 14px;
  }

  .send-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .send-btn svg {
    width: 18px;
    height: 18px;
    fill: white;
    margin-left: 8px;
  }

  /* 免责声明样式 */
  .disclaimer {
    text-align: center;
    font-size: 12px;
    color: #9ca3af;
    margin-top: 10px;
    padding: 0 10px;
  }
</style>




// WEBPACK FOOTER //
// src/components/tp/KmaiPage.vue